import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import DurhamLocation from './pages/durham-location';
import ChapelHillLocation from './pages/chapel-hill-location';
import Reservations from './pages/reservations';
import Catering from './pages/catering';
import Contact from './pages/contact';
import AnnouncementBar from './pages/home-landing/components/AnnouncementBar';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <AnnouncementBar />
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/Durham" element={<DurhamLocation />} />
        <Route path="/ChapelHill" element={<ChapelHillLocation />} />
        <Route path="/reservations" element={<Reservations />} />
        <Route path="/catering" element={<Catering />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;